/* Vera blog-animationer (25/10-2026) */
;(() => {
/* ---------- fælles: start når kortet ses ---------- */
function onSeen(el, fn) {
  if (!('IntersectionObserver' in window)) { el.classList.add('seen'); return fn() }
  el.classList.add('vba-wait')   // skjul først når JS kører; uden JS står kortet bare synligt
  const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { el.classList.remove('vba-wait'); el.classList.add('seen'); fn(); io.disconnect(); } }, { threshold: .12 });
  io.observe(el);
}

/* ================= A1: dybde ================= */
;(() => {
  // depth = y på forsiden (overhud 120-164, læderhud 164-330, underhud 330-460). layer = fane-index
  const C = [
    { has: ['bs', 'lu'], c: '#3f6fff', pill: 'Synligt blått ljus', nm: '415–450 nm', depth: 154, layer: 0, txt: 'Verkar ytligt i överhuden och bryter ner aknebakterierna inifrån. Påverkar inte kollagen och gör inget åt rynkor.', use: 'Akne och aknebakterier', ev: ['hi', 'Väl dokumenterat'] },
    { has: ['lu'], c: '#22a95a', pill: 'Synligt grönt ljus', nm: '520–530 nm', depth: 196, layer: 1, txt: 'Riktar sig mot melanocyterna, cellerna som bildar pigment, i övre läderhuden.', use: 'Pigmentfläckar, ojämn hudton', ev: ['lo', 'Tunt underlag'] },
    { has: ['bs', 'lu'], c: '#eba416', pill: 'Synligt gult ljus', nm: '590 nm', depth: 246, layer: 1, txt: 'Arbetar på mikrocirkulationen i övre till mellersta läderhuden. Beskrivs oftast som lugnande.', use: 'Rodnad, känslig hud', ev: ['lo', 'Tunt underlag'] },
    { has: ['bs', 'lu'], c: '#e5262b', pill: 'Synligt rött ljus', nm: '630–660 nm', depth: 318, layer: 1, txt: 'Når fibroblasterna i läderhuden och stimulerar kollagen typ I. Räkna med 8–12 veckor innan du ser skillnad.', use: 'Fina linjer och fasthet', ev: ['hi', 'Väl dokumenterat'] },
    { has: ['bs'], c: '#a3195b', pill: 'Osynligt nära infrarött', nm: '830–850 nm', depth: 448, layer: 2, txt: 'Osynligt för ögat. Når 5–10 mm ner, förbi läderhuden och in i underhud, blodkärl och lymfvävnad.', use: 'Inflammation och återhämtning', ev: ['mid', 'Rimligt underbyggt'] },
  ]
  const $ = id => document.getElementById(id)
  const el = $('depth'); if (!el) return; const info = $('depthInfo'), dots = $('depthDots'), beam = $('beam'), NS = 'http://www.w3.org/2000/svg'
  const X = 230, TOP = 36
  const LINK = { bs: ['Betterskin', '/products/nordic-flow-betterskin-led-mask'], lu: ['Vera Lumen', '/products/led-mask-7-farger'] }
  // mobil: skjul fanerne i SVG'en (de bliver 7 px), vis HTML-chips i stedet og zoom ind på blokken
  const svg = el.querySelector('svg'), mq = matchMedia('(max-width: 1000px)')
  const fit = () => svg.setAttribute('viewBox', mq.matches ? '20 0 540 470' : '0 0 680 480')
  fit(); mq.addEventListener('change', fit)
  const leds = C.map((c, i) => {
    const d = document.createElementNS(NS, 'circle'); d.setAttribute('cx', 170 + i * 30); d.setAttribute('cy', 21); d.setAttribute('r', 6); d.setAttribute('fill', c.c); d.setAttribute('class', 'ledon'); d.style.opacity = .3; $('ledDots').append(d)
    const b = document.createElement('button'); b.style.background = c.c; b.setAttribute('aria-label', c.pill); b.onclick = () => { manual = true; show(i) }; dots.append(b)
    return d
  })
  let cur = -1, manual = false
  function show(i) {
    cur = i; const c = C[i], d = c.depth, w = 44 + (d - 120) * .18   // keglen bliver bredere jo dybere den når
    const lx = X
    beam.style.transition = 'none'; beam.style.transform = 'scaleY(0)'
    $('beamCore').setAttribute('points', `${lx - 12},${TOP} ${lx + 12},${TOP} ${X + w / 2},${d - 14} ${X - w / 2},${d - 14}`)
    $('beamGlow').setAttribute('points', `${lx - 20},${TOP} ${lx + 20},${TOP} ${X + w},${d} ${X - w},${d}`)
    $('beamTip').setAttribute('points', `${X - w / 2 - 9},${d - 16} ${X + w / 2 + 9},${d - 16} ${X},${d + 6}`)
    ;['bg0', 'bg1'].forEach(k => $(k).setAttribute('stop-color', c.c))
    $('beamGlow').setAttribute('fill', c.c); $('beamTip').setAttribute('fill', c.c); $('entry').setAttribute('fill', c.c)
    void beam.getBoundingClientRect()
    beam.style.transition = 'transform 1.2s cubic-bezier(.3,.7,.2,1)'; beam.style.transform = 'scaleY(1)'
    leds.forEach((l, k) => l.style.opacity = k === i ? 1 : .3)
    ;[...$('depthLayers').children].forEach((t, k) => { t.style.background = k === c.layer ? c.c : ''; t.style.color = k === c.layer ? '#fff' : '' })
    ;[0, 1, 2].forEach(k => { const t = $('tab' + k); t.querySelector('rect').setAttribute('fill', k === c.layer ? c.c : '#efe9df'); t.querySelector('text').setAttribute('fill', k === c.layer ? '#fff' : '#6b655c') })
    ;[...dots.children].forEach((b, k) => b.classList.toggle('on', k === i))
    info.classList.add('fade')
    setTimeout(() => {
      info.innerHTML = `<div class="pill" style="background:${c.c}">${c.pill}<small class="num">${c.nm}</small></div>
        <p>${c.txt}</p>
        <div class="row"><span>Används mot</span><span>${c.use}</span></div>
        <div class="row"><span>Forskningen</span><span><span class="vba-ev ${c.ev[0]}">${c.ev[1]}</span></span></div>
        <div class="buy">Rekommenderad mask: ${c.has.map(k => `<a href="${LINK[k][1]}">${LINK[k][0]}</a>`).join(' eller ')}</div>`
      info.classList.remove('fade')
    }, 250)
  }
  onSeen(el, () => {
    show(0)
    const t = setInterval(() => { if (manual) return clearInterval(t); show((cur + 1) % C.length) }, 3600)
  })
})()

/* ================= A2: mål -> maske ================= */
;(() => {
  const G = [
    { goal: 'Fina linjer och fasthet', c: '#ff4d4d', wl: 'Rött 630–660 nm', sup: 'Stöd: nära infrarött 830–850 nm', bs: '630 nm + 850 nm', lu: '630 nm (utan infrarött)' },
    { goal: 'Akne och utbrott',        c: '#4c7dff', wl: 'Blått 415–450 nm', sup: 'Stöd: rött 660 nm', bs: '415 nm', lu: '460 nm' },
    { goal: 'Rodnad, känslig hud',     c: '#f2b632', wl: 'Gult 590 nm',      sup: 'Stöd: rött 660 nm', bs: '605 nm amber', lu: '590 nm' },
    { goal: 'Pigmentfläckar',          c: '#3ec46d', wl: 'Grönt 520–530 nm', sup: 'Stöd: rött 660 nm', bs: null, lu: '520 nm' },
    { goal: 'Inflammation, återhämtning', c: '#c23a7a', wl: 'Nära infrarött 830–850 nm', sup: 'Stöd: rött 660 nm', bs: '850 nm', lu: null },
  ]
  const el = document.getElementById('goal'); if (!el) return; const btns = document.getElementById('goalBtns'), res = document.getElementById('goalRes'), leds = document.getElementById('leds'), glow = document.getElementById('maskGlow')
  const NS = 'http://www.w3.org/2000/svg', DUR = 4200
  // LED-prikker i et gitter inden for masken
  const pts = []
  for (let y = 50; y <= 240; y += 17) for (let x = 50; x <= 190; x += 17) {
    const nx = (x - 120) / 80, ny = (y - 140) / 112
    if (nx * nx + ny * ny > 1) continue
    if (((x - 86) / 26) ** 2 + ((y - 118) / 16) ** 2 < 1 || ((x - 154) / 26) ** 2 + ((y - 118) / 16) ** 2 < 1) continue
    if (Math.abs(x - 120) < 26 && Math.abs(y - 208) < 12) continue
    const d = document.createElementNS(NS, 'circle'); d.setAttribute('cx', x); d.setAttribute('cy', y); d.setAttribute('r', 3.6); d.setAttribute('class', 'led'); d.setAttribute('fill', '#aab0ba'); leds.append(d); pts.push(d)
  }
  el.style.setProperty('--dur', DUR + 'ms')
  G.forEach((g, i) => {
    const b = document.createElement('button'); b.style.setProperty('--gc', g.c); b.innerHTML = `${g.goal}<span class="bar"></span>`
    b.onclick = () => { manual = true; el.classList.add('manual'); show(i) }; btns.append(b)
  })
  let cur = -1, manual = false
  function show(i) {
    cur = i; const g = G[i]
    ;[...btns.children].forEach((b, k) => { b.classList.remove('on'); void b.offsetWidth; b.classList.toggle('on', k === i) })
    pts.forEach((p, k) => { setTimeout(() => p.setAttribute('fill', g.c), (k % 9) * 35) })
    glow.setAttribute('fill', g.c); glow.setAttribute('opacity', '.45')
    res.classList.add('fade')
    setTimeout(() => {
      const row = (name, price, v, href) => `<div class="prod${v ? '' : ' no'}"><span><b>${name}</b> <span style="white-space:nowrap">· ${price}</span></span>${v ? `<span class="y">✓ ${v}</span>` : '<span class="n">Har inte färgen</span>'}</div>`
      res.innerHTML = `<div class="k">Färgen du behöver</div>
        <div class="wl"><i style="background:${g.c};color:${g.c}"></i>${g.wl}</div>
        <div class="sup">${g.sup}</div>
        <div class="k">Finns i</div>
        ${row('Nordic Flow Betterskin', '1 499 kr', g.bs)}
        ${row('Vera Lumen 7 färger', '799 kr', g.lu)}
        <div class="ctas">
          <a class="vba-cta${g.bs ? '' : ' off'}" href="/products/nordic-flow-betterskin-led-mask">Se Betterskin →</a>
          <a class="vba-cta ghost${g.lu ? '' : ' off'}" href="/products/led-mask-7-farger">Se Vera Lumen →</a>
        </div>`
      res.classList.remove('fade')
    }, 220)
  }
  onSeen(el, () => {
    show(0)
    const t = setInterval(() => { if (manual) return clearInterval(t); show((cur + 1) % G.length) }, DUR)
  })
})()

/* ================= B1: benet ================= */
;(() => {
  const el = document.getElementById('leg'); if (!el) return; const NS = 'http://www.w3.org/2000/svg'
  // ophobet ved anklen (fast klump) + 3 dråber der langsomt falder ned og lander i klumpen
  const POOL = [[-14, 350], [-2, 354], [10, 350], [22, 354], [-8, 340], [6, 342], [18, 340], [0, 330], [12, 330]]
  const sets = [...el.querySelectorAll('.drops')].map(g => {
    const v = g.parentNode.querySelector('.vessel'), len = v.getTotalLength(), up = g.dataset.dir === 'up'
    const mk = () => { const c = document.createElementNS(NS, 'circle'); c.setAttribute('r', 5.5); c.setAttribute('fill', '#8fc0ff'); g.append(c); return c }
    if (up) return { v, len, up, ds: Array.from({ length: 12 }, (_, i) => ({ c: mk(), t: i / 12 })) }
    POOL.forEach(([x, y]) => { const c = mk(); c.setAttribute('cx', x); c.setAttribute('cy', y) })
    return { v, len, up, ds: [0, 1, 2].map(i => ({ c: mk(), t: .85 - i * .3 })) }
  })
  let last = 0
  function frame(now) {
    const dt = last ? Math.min(50, now - last) / 1000 : 0; last = now
    for (const s of sets) s.ds.forEach(d => {
      if (s.up) d.t = (d.t + dt * .3) % 1
      else { d.t -= dt * .16; if (d.t < .1) d.t = .95 }                    // falder og forsvinder i klumpen
      const p = s.v.getPointAtLength(s.len * d.t)
      d.c.setAttribute('cx', p.x); d.c.setAttribute('cy', p.y)
      d.c.setAttribute('opacity', s.up ? Math.min(1, d.t * 8, (1 - d.t) * 8) : Math.min(1, (d.t - .1) * 6, (1 - d.t) * 8))
    })
    requestAnimationFrame(frame)
  }
  onSeen(el, () => requestAnimationFrame(frame))
})()


})()
